module.exports = __webpack_public_path__ + "img/3-4-raiders-locker-room.acec147f.jpg";